import {
  SET_MASTER_TB_DATA,
  UPDATE_MASTER_TB,
  REMOVE_MASTER_TB,
} from "./actionType";

export default function reducer(state = [], action) {
  switch (action.type) {
    case SET_MASTER_TB_DATA:
      return [...action.payload];
    case UPDATE_MASTER_TB:
      return [
        ...state.slice(0, action.index),
        {
          ...action.payload,
        },
        ...state.slice(action.index + 1),
      ];
    case REMOVE_MASTER_TB:
      return [
        ...state.slice(0, action.index),
        ...state.slice(action.index + 1),
      ];
    default:
      return state;
  }
}
